// 상태 문자열 → 배지 색상 클래스 매핑 (운영관리 공통)
export function statusClass(status: string): string {
  if (/취소/.test(status)) return 'st-cancel';
  if (/오류발생/.test(status)) return 'st-danger';
  if (status === '종료') return 'st-cancel'; // 신청·문의 종료
  if (/완료/.test(status)) return 'st-success'; // 완료/답변완료/개선완료 등
  if (status === '서비스중') return 'st-live';
  if (status === '대기') return 'st-neutral'; // 신청·문의 대기
  if (/(중|진행|패치|수정)/.test(status)) return 'st-progress';
  if (/(요청|계약금입금|일부입금)/.test(status)) return 'st-info';
  return 'st-neutral'; // 미입금, 미진행상태, 상담 등
}
